module.exports = {"url":"https://propapanda.netlify.com","googleMapsApiKey":"AIzaSyAyg6IlXL7AZn6S-jJFdFLCEObO-UdVdJ8"}


//////////////////
// WEBPACK FOOTER
// ./site.json
// module id = 108
// module chunks = 35783957827783 161653746587813 191319344601756